import { render } from "./BtnPrimarioNegativo.vue?vue&type=template&id=adcf305e&scoped=true"
import script from "./BtnPrimarioNegativo.vue?vue&type=script&lang=js"
export * from "./BtnPrimarioNegativo.vue?vue&type=script&lang=js"

import "./BtnPrimarioNegativo.vue?vue&type=style&index=0&id=adcf305e&scoped=true&lang=scss"

import exportComponent from "/home/cubel/PhpstormProjects/failder/vue-failder/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adcf305e"]])

export default __exports__